import { HandleField, Input, ProfilePicture } from '@/component';
import type { CurrentUser } from '@/hook/useCurrentUser';

interface WelcomeIdentityStepProps {
  user: CurrentUser;
  name: string;
  handle: string;
  onNameChange: (value: string) => void;
  onHandleChange: (value: string) => void;
}

/** First run, step 1: name, handle with live availability, and the picture. */
export function WelcomeIdentityStep({ user, name, handle, onNameChange, onHandleChange }: WelcomeIdentityStepProps) {
  return (
    <div className="mt-11">
      <h1 className="text-[38px] font-semibold leading-[1.08] tracking-[-0.03em]">What should people call you?</h1>
      <p className="mt-3 max-w-[46ch] text-base leading-[1.5] text-mute">
        Your handle is how friends find you. Your name is what shows on the display when you sing.
      </p>
      <div className="mt-8 flex max-w-[420px] flex-col gap-5">
        <Input label="Name" value={name} onChange={(event) => onNameChange(event.target.value)} maxLength={32} />
        <HandleField value={handle} onChange={onHandleChange} />
        <ProfilePicture user={user} layout="row" />
      </div>
    </div>
  );
}
